<template>
    <div>

        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol>
                                <strong>{{$t('myRequests')}}</strong>
                            </CCol>
                            <CCol  style="text-align: end;">
                                <!--                <CButton @click="AddAllRefer()" size="sm" color="primary">-->
                                <!--                  {{ $t('components.referSelected') }}-->
                                <!--                </CButton>-->
                            </CCol>

                        </CRow>
                        <CRow>
                            <CCol col="3">
                                <date-picker

                                        :label="$t('components.startDate')"
                                        v-model="start_date"></date-picker>
                            </CCol>
                            <CCol col="3">
                                <date-picker
                                        :label="$t('components.endDate')"
                                        v-model="end_date"></date-picker>

                            </CCol>

                        </CRow>

                    </CCardHeader>
                    <CCardBody>

                        <CDataTable
                                :items="items_buy"
                                :fields="fields"
                                column-filter
                                :items-per-page="20"
                                hover
                                @row-clicked="table_row_clicked"

                                sorter
                                pagination
                        >
                            <template #row="{item}">

                                <td style="text-align: center">
                                    <p >{{ item.row_id + 1 }}</p>

                                </td>

                            </template>

                            <template #price="{item}">

                                <td>
                                    <p  style="float: right" >{{ get_currency(get_total_price(item)) }}</p>

                                </td>


                            </template>
                            <template #customer="{item}">

                                <td>
                                    <p >{{ item.partyName }}</p>

                                </td>

                            </template>
                            <template #toziKonande="{item}">

                                <td>
                                    <p v-if="item.toziKonande!=null" >{{ item.toziKonande }}</p>

                                </td>

                            </template>
                            <template #user="{item}">

                                <td>
                                    <p >{{ item.createdBy }}</p>

                                </td>

                            </template>

                          <template #deliveryTime="{item}">
                            <td>
                              <p >{{ get_date(item.deliveryTime) }}</p>
                            </td>
                          </template>
                            <template #operation="{item}">
                                <td>
                                    <CButton v-if="item.statusId !=0"
                                             color="primary"
                                             variant="outline"
                                             square
                                             :title="$t('buttons.returnDocument')"
                                             size="sm"
                                             @click="goReturnDocument(item)"
                                    >
                                        <CIcon name="cilTransfer"/>
                                    </CButton>

                                    <CButton
                                            class="m-1"
                                            color="primary"
                                            variant="outline"
                                            square
                                            :title="$t('buttons.show')"
                                            size="sm"
                                            @click="goShowDocument(item)"
                                    >
                                        <CIcon name="cil-speedometer"/>
                                    </CButton>

                                    <CButton v-if="item.statusId !=0 && item.toziKonande==null"
                                             class="m-1"
                                             color="primary"
                                             variant="outline"
                                             square
                                             :title="$t('buttons.refer')"
                                             size="sm"
                                             @click="AddRefer(item)"
                                    >
                                        <CIcon name="cilShare"/>
                                    </CButton>

                                    <CButton v-if="item.statusId ==0"
                                             class="m-1"
                                             color="primary"
                                             square
                                             size="sm"
                                             :title="$t('buttons.finalize')"
                                             @click="Finalize(item)"
                                    >
                                        <CIcon name="cil-https"/>
                                    </CButton>
                                </td>
                            </template>


                        </CDataTable>

                    </CCardBody>
                    <CCardFooter>

                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>
        <CModal
                :show.sync="show_factor_detail"
                :no-close-on-backdrop="true"
                :centered="true"
                :title="$t('requestDetail')"
                size="lg"
                color="dark"
        >
            <form-wizard step-size="sm"  :startIndex="2" color="#248f48" :validate-on-back="false">
                <tab-content :title="$t('tables.unit')">
                </tab-content>
                <tab-content :title="$t('accountingAdmin')">
                </tab-content>
                <tab-content :title="$t('manager')">
                </tab-content>
            </form-wizard>
            <CDataTable
                    :items="selected_factor"
                    :fields="factor_product_fields"
                    column-filter
                    :items-per-page="200"
                    hover
                    sorter
                    pagination
            >
                <template #row="{item,index}">

                    <td>
                        <p >{{ index + 1 }}</p>

                    </td>

                </template>

            </CDataTable>

            <template #footer>
                <CButton @click="accept_factor"

                         color="secondary"
                >{{$t('acceptRequest')}}
                </CButton>
                <CButton
                        @click="show_factor_detail = false"
                        color="success"
                >{{ $t("buttons.close") }}
                </CButton>
            </template>
        </CModal>

    </div>

</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import moment from 'moment-jalaali'

    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
    var items_data = [];

    //local registration
    import FormWizard from 'vue-form-wizard/src/components/FormWizard'
    import TabContent from 'vue-form-wizard/src/components/TabContent'
    import 'vue-form-wizard/dist/vue-form-wizard.min.css'
    //component code
    export default {
        name: 'Login',
        components: {
            FormWizard,
            TabContent,
            Treeselect,
            'test-dynamic': () => import('../documents/PrintDocument'),

        },
        data() {
            return {
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                // show_document: 'test-dynamic',
                printed_doc_id: 0,
                name: '',
                show_factor_detail: false,

                start_date: '',
                end_date: '',
                submit_refer: 0,
                refer_person: null,
                selected_template: 0,
                id_checkbox_items: [],
                item_sell_array: [],
                items_buy: [],
                selected_factor: [],
                factor_product_fields: [
                    {key: 'row', label: this.$t('tables.sharp'), _style: 'width:2%'},
                    {key: 'productName', label: this.$t('components.productName'), _style: 'width:10%'},
                    {key: 'qty', label: this.$t('tables.qty'), _style: 'width:5%'},
                    {key: 'summary', label: this.$t('tables.summary'), _style: 'width:15%'},
                    // {key: 'supplierName', label: "تامین کننده", _style: 'width:15%'},
                ],
                fields: [
                    {key: 'row', label: this.$t('tables.sharp'), _style: 'width:2%'},
                    {key: 'masterId', label: this.$t('orderId'), _style: 'width:10%'},

                    {key: 'deliveryTime', label: this.$t('requestDate'), _style: 'width:15%'},
                    {key: 'userUnitTitle', label:this.$t('departmanName'), _style: 'width:15%'},
                    // {key: 'انبار', _style: 'width:10%'},
                    // {key: 'price', label: this.$t('tables.amount'), _style: 'width:10%'},
                    // {key: 'customer', label: this.$t('tables.customer'), _style: 'width:20%'},
                    {key: 'priorityTitle', label: this.$t('tables.type'), _style: 'width:20%'},
                    {key: 'createdBy', label: this.$t('orderBy'), _style: 'width:15%'},
                    // {key: 'toziKonande', label: this.$t('tables.driver'), _style: 'width:15%'},

                    // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
                    // {key: 'select', label: this.$t('tables.select'),},

                ],

                table_clicks: 0,
                table_clicks_timer: null,
                details: [],

                status_form: 0,
                load_persons({action, searchQuery, callback}) {
                    var self = this;

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);

                            axios.post('GetUsers', formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                                // localStorage.setItem("api_token", response.data.access_token);
                                // self.$router.push({ path: 'notes' });
                            })
                                .catch(function (error) {

                                    console.log(error);
                                });


                            //  const options = this.get_keywords(searchQuery);
                            // const options = [1, 2, 3, 4, 5].map(i => ({
                            //     id: `${searchQuery}-${i}`,
                            //     name: `${searchQuery}-${i}`,
                            // }))

                        })
                    }
                },
                normalizer_persons(node) {
                    return {
                        id: node.userId,
                        label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
                    }
                },

            }
        }, mounted() {

            this.start_date = this.get_day_before_today(1);
            this.end_date = this.get_today();

            this.$root.root_validate_errors = [];

            // this.get_all_data();
            bus.$on('update_orders', (data) => {
                this.get_all_data()
            });
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {
            '$route.params.person_id': function () {
                // this.get_all_data();
            },
            'start_date': function () {
                this.get_all_data();
            },
            'end_date': function () {
                this.get_all_data();
            }
        },
        methods: {
            get_total_price(item) {
                var total_price = 0
                item.details.forEach((val) => {
                    total_price = total_price + (val.price * val.qty)
                });
                return total_price;
            },
            get_all_data() {
                this.get_lists_buy();

            },
            table_row_clicked(item, index) {

                this.table_clicks++;
                if (this.table_clicks == 1) {
                    this.table_clicks_timer = setTimeout(() => {
                        // this.result.push(event.type);
                        this.table_clicks = 0
                    }, 500);
                } else if (this.table_clicks > 1) {
                    clearTimeout(this.table_clicks_timer);
                    this.selected_factor = item.details;
                    this.show_factor_detail = true;
                    this.status_form = item.masterId;
                    this.table_clicks = 0

                }

            },
            accept_factor() {
                var self = this;
                this.show_factor_detail = false

                const formData = new FormData();
                var url = "AddRequestMasterStatus";
                formData.append("StatusId", 1);

                formData.append("RequestMasterId", self.status_form);

                // formData.append("id", 1);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    if (content_data.statusCode == 0) {
                        // this.get_lists_buy();
                        bus.$emit("update_orders", "");

                        self.$root.modal_component.show_api_response_modals(response);

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });


            },
            get_lists_buy() {
                var self = this;


                const formData = new FormData();
                var url = "GetPurchaseRequests";
                formData.append("docType", 1);
                if (self.$route.params.person_id != null) {
                    formData.append("PersonId", self.$route.params.person_id);

                } else {
                    formData.append("PersonId", 0);
                }
                formData.append("FirstDate", self.start_date);
                formData.append("SecondDate", self.end_date);

                // formData.append("id", 1);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    if (content_data.statusCode == 0) {
                        self.items_buy = content_data.data.map((item, row_id) => {
                            return {...item, row_id}

                        });
                        self.items_buy = self.items_buy.filter(x => x.userId == localStorage.getItem("user_id"))
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },

            Finalize(item) {
                var self = this;


                const formData = new FormData();

                var url = "AddFactorToFinal";

                formData.append("id", item.recId);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.$root.modal_component.show_api_response_modals(response);

                    if (content_data.statusCode == 0) {
                        item.statusId = 1;
                    } else {
                        // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            send_to_customer(item) {
                var self = this;


                const formData = new FormData();

                var url = "SendFactorToTelegramBoth";

                formData.append("id", item.recId);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.$root.modal_component.show_api_response_modals(response);

                    if (content_data.statusCode == 0) {
                        item.statusId = 1;
                    } else {
                        // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            goReturnDocument(item) {
                this.$router.push({
                    path: '/dashboard/documents/return/' + item.recId + "/false",
                    params: {passed_data: "salam hamidddd"}
                });
            },
            goShowDocument(item) {

                this.$router.push({path: '/dashboard/documents/show/' + item.recId});
            },
            goPrintDocument(item) {
                bus.$emit("print_confirm", item.recId);


            },
            AddRefer(item) {
                this.submit_refer = item.recId;
            },

            AddAllRefer() {
                this.submit_refer = -1;
                if (this.id_checkbox_items.length == 0) {
                    console.log("validate form is false" + this.validate_errors);
                    this.submit_refer = 0;

                }
            },

            insert_refer() {
                let self = this;

                if (this.submit_refer != -1) {


                    this.id_checkbox_items = [];
                } else {
                    if (this.id_checkbox_items.length == 0) {
                        console.log("validate form is false" + this.validate_errors);
                        self.submit_refer = 0;
                        self.id_checkbox_items = [];

                        return true;
                    }

                }
                if (this.refer_person == null) {
                    console.log("validate form is false" + this.validate_errors);

                    return true;
                }
                let url;
                // if (this.status_form == 0) {
                url = "AddFactorRefer";
                // }
                if (this.submit_refer != -1) {
                    const formData = new FormData();

                    formData.append('PersonId', this.refer_person);

                    formData.append('MasterFactorId', this.submit_refer);
                    axios.post(url, formData, {}).then((res) => {

                        self.submit_refer = 0;
                        self.id_checkbox_items = [];

                        self.refer_person = null;

                      self.$root.modal_component.show_api_response_modals(res);
                      self.get_all_data()
                    })
                        .catch(function (error) {

                            console.log(error);
                        });
                } else {
                    self.id_checkbox_items.forEach((val) => {

                        const formData = new FormData();

                        formData.append('PersonId', this.refer_person);

                        formData.append('MasterFactorId', val);
                        axios.post(url, formData, {}).then((res) => {

                        })
                            .catch(function (error) {

                                console.log(error);
                            });
                    });
                    self.id_checkbox_items = [];
                    self.submit_refer = 0;
                    self.id_checkbox_items = [];

                    self.refer_person = null;

                    this.get_all_data()
                }


            },

        },

    }

</script>
<style>
    .vue-form-wizard .wizard-progress-bar {
        float: right !important;
    }

    .vue-form-wizard .wizard-card-footer .wizard-footer-left {
        float: right !important;
    }

    .vue-form-wizard .wizard-card-footer .wizard-footer-right {
        float: left !important;
    }

    .wizard-tab-content {
        display: none;
    }

    .wizard-card-footer {
        display: none;
    }

    .wizard-header {
        display: none;
    }
</style>
